export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9950.f8993b79.jpg";